

<template>
  <div class="table-responsive">

    <table class="table table-striped bg-white" style="width: 70vw; ">
      <thead>
      <tr class="sticky-header">
        <th style="width: 1vw;">ردیف</th>
        <th  >مسئله  </th>
        <th> عنوان نماگر</th>
        <th >نوع نماگر     </th>
        <th>فرمول نماگر  </th>
        <th>مقدار ابتدای سال   </th>
        <th style="width: 6.3vw;">مقدار انتهای سال   </th>
        <th >مستندات پیوست  </th>
        <th style="width: 6vw;">وضعیت مسئله    </th>
        <th >راهکار اصلاحی پیشنهادی    </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in all_items">
        <td>{{index+1}}</td>
        <td>{{item.problem && item.problem.title}}</td>
        <td>{{item.title_photographer}}</td>
        <td>{{item.type_photographer}}</td>
        <td>{{item.formula}}</td>
        <td>{{item.value_now}}</td>
        <td>
          <input type="text" class="form-control text-center" v-model="item.value_final">
        </td>
        <td>
          <button @click.prevent="showDocs(item.id)" class="btn btn-submit-1 btn-primary">تکمیل | بروزرسانی</button>
        </td>
        <td>
          <select class="form-select" v-model="item.problem_status" id="">
            <option :value="1">اتمام</option>
            <option :value="0">استمرار</option>
          </select>
        </td>
        <td>
          <textarea v-model="item.solution" cols="30" rows="10" class="form-control"></textarea>
        </td>
      </tr>
      </tbody>
    </table>
    <center v-if="all_items.length" class="mb-2 d-flex align-items-center justify-content-center">
      <button @click.prevent="store"  class="btn btn-primary btn-submit-1">ذخیره</button>
      <button @click.prevent="downloadCompanyDocs"  class="btn btn-primary btn-submit-1 mx-2">خروجی مستندات</button>
      <button  @click.prevent="exportWord"  class="btn btn-primary btn-submit-1 mx-2">خروجی Word</button>
    </center>
  </div>

  <DocumentsModal
      :status_insert="true"
      :id="id_item"
      v-if="showDocumentsModal"
      :visible="showDocumentsModal"
      @close="showDocs"
  />
</template>
<script>
import {useToast} from "vue-toastification";
import DocumentsModal from "@/components/Impact_Assessment/DocumentsModal/DocumentsModal.vue";
const toast = useToast();

export  default {
  components: {DocumentsModal},
  data(){
    return{
      all_items:[],
      documents:[],
      showDocumentsModal: false,
      id_item: '',
      id_route: this.$route['params']['id'],
    }
  },
  methods:{
    exportWord() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`); // اضافه کردن توکن
      const formdata = new FormData();
      formdata.append('company_id', this.id_route);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/impact-assessment/get_word`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.download_url) {
              // باز کردن لینک در تب جدید
              window.open(result.download_url, '_blank');
            } else {
              throw new Error('Download URL not provided');
            }
          })
          .catch(error => {
            toast.error('خطا در دریافت فایل!');
          });
    },

    showDocs(id){
      this.showDocumentsModal = !this.showDocumentsModal;
      this.id_item = id
    },
    addDocs(){},
    deleteMethodFile(){},
    all(){

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('company_id',this.id_route)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/Problem_identification/completed_problems_photograph`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              return;
            }
            if (result.details){
              this.all_items = result.details
            }

          })
          .catch();
    },
    store(){

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('items',JSON.stringify(this.all_items))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/impact-assessment/store_photographer`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              toast.error(result.error)

              return;
            }
            toast.success(result.message)
             this.all()

          })
          .catch();
    },
    async downloadCompanyDocs() {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        myHeaders.append("company_id", this.id_route);


        const response = await fetch(`${this.base_url}/impact-assessment/download_photographer_doc`, {
          method: "GET",
          headers: myHeaders,
        });

        if (!response.ok) {
          const errorData = await response.json();
        toast.error(errorData.error)
        }

        // دریافت فایل ZIP به صورت blob
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // ایجاد لینک برای دانلود
        const a = document.createElement("a");
        a.href = url;
        a.download = `company_docs_${Date.now()}.zip`; // نام فایل دانلودی
        document.body.appendChild(a);
        a.click();
        a.remove();

        // آزاد کردن URL blob
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error.message);
        this.$toast.error(error.message || "خطا در ارتباط با سرور");
      }
    }

  },
  mounted() {
    this.all()
  },
}

</script>
<style scoped>

</style>